import { api } from '@/lib/api';
import type {
  IApiResponse,
  IAiApiLogPageResponse,
  IAiCostSummary,
  IAiCostBreakdown,
  AiCostGranularity,
} from '@skystone/shared';

interface GetLogsParams {
  page?: number;
  pageSize?: number;
  from?: string;
  to?: string;
  userId?: string;
  success?: string;
  escalated?: string;
  model?: string;
  endpoint?: string;
}

export const aiApiLogApi = {
  getLogs: async (params: GetLogsParams): Promise<IAiApiLogPageResponse> => {
    const search = new URLSearchParams();
    if (params.page) search.set('page', String(params.page));
    if (params.pageSize) search.set('pageSize', String(params.pageSize));
    if (params.from) search.set('from', params.from);
    if (params.to) search.set('to', params.to);
    if (params.userId) search.set('userId', params.userId);
    if (params.success) search.set('success', params.success);
    if (params.escalated) search.set('escalated', params.escalated);
    if (params.model) search.set('model', params.model);
    if (params.endpoint) search.set('endpoint', params.endpoint);
    const query = search.toString();
    const url = query ? `/admin/ai-api-log?${query}` : '/admin/ai-api-log';
    const result = await api.get<IApiResponse<IAiApiLogPageResponse>>(url);
    return result.data;
  },

  getCostSummary: async (granularity: AiCostGranularity, windowSize: number): Promise<IAiCostSummary> => {
    const result = await api.get<IApiResponse<IAiCostSummary>>(
      `/admin/ai-api-log/cost-summary?granularity=${granularity}&windowSize=${windowSize}`,
    );
    return result.data;
  },

  getCostBreakdown: async (from?: string, to?: string): Promise<IAiCostBreakdown> => {
    const search = new URLSearchParams();
    if (from) search.set('from', from);
    if (to) search.set('to', to);
    const query = search.toString();
    const url = query ? `/admin/ai-api-log/cost-breakdown?${query}` : '/admin/ai-api-log/cost-breakdown';
    const result = await api.get<IApiResponse<IAiCostBreakdown>>(url);
    return result.data;
  },
};
